import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';

export default class AdminStoriesStoryRoute extends Route {
  // Services
  @service breadcrumb;
  @service store;

  // Hooks
  async model({ story_id }) {
    const { content } = await this.store.request(findRecord('story', story_id));

    return content.data;
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
